import axios from "axios";

const API = axios.create({
baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/complaints`,
});

// 📖 Get All Complaints (POST with filters)
export async function fetchComplaints(payload = {}) {
  try {
    const res = await API.post("/list", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✏️ Update Complaints
export async function updateComplaints(id, payload) {
  try {
    const res = await API.put(`/${id}/status`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ➕ Create Plan
export async function replyComplaints(complaintId, payload) {
  try {
    const res = await API.post(`/${complaintId}/reply`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}



// 🗑️ Delete Plan
export async function deleteComplaints(id) {
  try {
    const res = await API.delete(`/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}